export default __webpack_public_path__ + "static/media/2484.c8c23048.png";